var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.Loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_c('v-chip',{attrs:{"color":_vm.labelColor,"dark":"","label":""}},[_vm._v(" "+_vm._s(this.Name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }